/**
 * @fileOverView
 * @description Peep Full View<br>
 * @copyright 2015-present Flatirontek LLC
 **/

var AmpersandView = require('ampersand-view');
var PeepTemplate = require('../../templates/widgets/peepfulltemplate.html');
var config = require("../../etc/config");
var Params = require("../../collections/params");
var ParamView = require("./param");
var app = require("ampersand-app");

var PeepFullView = AmpersandView.extend({

    template: PeepTemplate,

    render: function(){
        this.renderWithTemplate();
    },

    events:{
        "scroll" : "infiniteScroll"
    },

    infiniteScroll: function(){
        if (this.el.scrollHeight - this.el.scrollTop - 10 <= this.el.clientHeight && app.peep.key!=null) {
            console.log('get more somethings');
        }
    }
});

module.exports = PeepFullView;
